import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { RouterModule } from '@angular/router'
import { AlmacenMenajeriaRoutingModule } from './almacen-menajeria-routing.module'
import { AlmacenMenajeriaComponent } from './almacen-menajeria.component'
import { DialogInventarioMenajeriaComponent } from './inventario/dialog-inventario-menajeria/dialog-inventario-menajeria.component'
import { InventarioComponent } from './inventario/inventario.component'

@NgModule({
  declarations: [
    InventarioComponent,
    AlmacenMenajeriaComponent,
    DialogInventarioMenajeriaComponent
  ],
  imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    MatIconModule,
    BrowserModule,
    MatCardModule,
    MatTableModule,
    MatDialogModule,
    MatFormFieldModule,
    MatPaginatorModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    AlmacenMenajeriaRoutingModule
  ]
})
export class AlmacenMenajeriaModule {}
